import React from 'react';
import PropTypes from 'prop-types';
import { renderFields } from '../../utils/RenderUtil';
import { pickDataAttributes } from '../../utils';

export class FieldGroup extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.renderFields = this.renderFields.bind(this);
  }

  renderFields() {
    return renderFields(this.props);
  }

  render() {
    const disabledStyle = {
      pointerEvents: 'none',
      opacity: 0.5,
    };

    const { className, disabled } = this.props;

    const dataAttributes = pickDataAttributes(this.props);

    return (
      <div className={className} style={disabled ? disabledStyle : null} {...dataAttributes}>
        {this.renderFields()}
      </div>
    );
  }
}
